import { Block } from 'ui-kit/blocks'
import { Heading, Text } from 'ui-kit/typography'
import { Picture } from 'ui-kit/picture'
import ImageMob1x from './image-ai-mob@1x.webp'
import ImageMob2x from './image-ai-mob@2x.webp'
import ImageDesk1x from './image-ai-desk@1x.webp'
import ImageDesk2x from './image-ai-desk@2x.webp'
import classes from './SolutionAI.module.scss'

export const SolutionAI = ({ text, title }) => {
  return (
    <Block
      as={'section'}
      variant={'solidMob'}
      pad={'base'}
      divider={'mobile'}
      className={classes.section}
    >
      <Heading as={'h2'} size={'xl'} center balance className={classes.title}>
        {title}
      </Heading>
      <Text size={'lg'} center balance className={classes.subtitle}>
        {text}
      </Text>
      <Picture
        className={classes.image}
        mobSrc1x={ImageMob1x.src}
        mobSrc2x={ImageMob2x.src}
        deskSrc1x={ImageDesk1x.src}
        deskSrc2x={ImageDesk2x.src}
        alt={title}
        width={1100}
        height={251}
        lazyLoad
      />
    </Block>
  )
}
